import React from "react";
import DetailData from "../../components/user/dataHistory";
import Layout from "../../components/layouts/verticalLayout";

const DataHistoryPage = () => {
  return (
    <Layout
      body={
        <>
          <DetailData />
        </>
      }
    />
  );
};

DataHistoryPage.propTypes = {};

export default DataHistoryPage;
